import { render, staticRenderFns } from "./RelatorioIAModal.vue?vue&type=template&id=55ff902c"
import script from "./RelatorioIAModal.vue?vue&type=script&lang=js"
export * from "./RelatorioIAModal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioIAModal.vue?vue&type=style&index=0&id=55ff902c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports